<!--
/**
* @name: List.vue
* @description: 交易管理-订单详情页面
* @author: 杨波
* @create: 2020/10/08 14:06:58
* @update: 2020/10/08 14:06:58
*/
-->

<template>
  <y-view>
    <div class="form-box">
      <y-form title="基本信息" id="basic" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">订单号：{{ orderDetailInfo.orderSn }}</y-query-item>
          <y-query-item :class="css.query_item">订单状态：{{ orderDetailInfo.orderStatusName }}</y-query-item>
          <y-query-item :class="css.query_item">终端来源：{{ orderDetailInfo.clientTypeName }}</y-query-item>
          <y-query-item :class="css.query_item">销售渠道：{{ orderDetailInfo.saleChannelName }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">贸易模式：{{ orderDetailInfo.tradeModeName }}</y-query-item>
          <y-query-item :class="css.query_item">经营方式：{{ orderDetailInfo.operateModeName }}</y-query-item>
          <y-query-item :class="css.query_item">是否分享订单：{{ orderDetailInfo.isShareBuy == '1' ? '是' : '否' }}</y-query-item>
          <y-query-item :class="css.query_item">下单场景：{{ orderDetailInfo.sceneName }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">活动编号：{{ orderDetailInfo.activitySn }}</y-query-item>
          <y-query-item :class="css.query_item">客户名称：{{ orderDetailInfo.ownerUsername }}</y-query-item>
          <y-query-item :class="css.query_item">分销员：{{ orderDetailInfo.promotionUsername }}</y-query-item>
          <y-query-item :class="css.query_item">角色：{{ orderDetailInfo.roleName }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <!-- <y-query-item :class="css.query_item">收益比例：{{ orderDetailInfo.profitShareRatio }}</y-query-item> -->
          <y-query-item :class="css.query_item">门店名称：{{ orderDetailInfo.storeName }}</y-query-item>
          <y-query-item :class="css.query_item">客商：{{ orderDetailInfo.merchantCustomerName }}</y-query-item>
          <y-query-item :class="css.query_item">推广公司：{{ orderDetailInfo.merchantCompanyName }}</y-query-item>
          <y-query-item :class="css.query_item">组织机构：{{ orderDetailInfo.orgName }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">下单时间：{{ orderDetailInfo.createTime }}</y-query-item>
          <y-query-item :class="css.query_item">发货时间：{{ orderDetailInfo.shippedTime }}</y-query-item>
        </y-query>
      </y-form>
      <div class="spliter"></div>
      <y-form title="收货信息" id="recive" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">收货人：<insensitive :val="orderDetailInfo.orderAddress.consignee" type="name"></insensitive></y-query-item>
          <y-query-item :class="css.query_item">联系电话：{{ orderDetailInfo.orderAddress.consigneeMobile }}</y-query-item>
          <y-query-item :class="css.query_item">身份证姓名：{{ orderDetailInfo.orderAddress.buyerName }}</y-query-item>
          <y-query-item :class="css.query_item">身份证号：{{ orderDetailInfo.orderAddress.buyerId }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">身份证人像面：<a @click="previewImg(1)">查看</a></y-query-item>
          <y-query-item :class="css.query_item">身份证国徽面：<a @click="previewImg(2)">查看</a></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item>收货地址：<insensitive :val="orderDetailInfo.orderAddress.fullAddress" type="fullAddress"></insensitive></y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false">
          <y-query-item>配送方式：{{ orderDetailInfo.orderAddress.providerName }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false">
          <y-query-item>订单备注：{{ orderDetailInfo.orderAddress.userRemark }}</y-query-item>
        </y-query>
      </y-form>
      <div class="spliter"></div>
      <y-form title="支付信息" id="pay" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">支付方式：{{ orderDetailInfo.orderPayment.payName }}</y-query-item>
          <y-query-item :class="css.query_item">支付金额：{{ orderDetailInfo.orderPayment.payAmount }}</y-query-item>
          <y-query-item :class="css.query_item">支付时间：{{ orderDetailInfo.orderPayment.payTime }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">支付流水号：{{ orderDetailInfo.orderPayment.transactionNo }}</y-query-item>
          <y-query-item :class="css.query_item" v-if="orderDetailInfo.orderStatus != 'un_paid' && orderDetailInfo.payType == 1"
            >支付凭证： <a @click="previewImg(3)">查看</a></y-query-item
          >
        </y-query>
      </y-form>
      <div class="spliter"></div>
      <y-form title="报关信息" id="customs" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">报关订单号：{{ orderDetailInfo.orderCustomsInfo.no }}</y-query-item>
          <y-query-item :class="css.query_item">关区：{{ orderDetailInfo.orderCustomsInfo.customs }}</y-query-item>
          <y-query-item :class="css.query_item">电商平台名称：{{ orderDetailInfo.orderCustomsInfo.ebpName }}</y-query-item>
          <y-query-item :class="css.query_item">电商平台编码：{{ orderDetailInfo.orderCustomsInfo.ebpCode }}</y-query-item>
        </y-query>
        <y-query spaceBetween :hasSearchButton="false" :class="css.query">
          <y-query-item :class="css.query_item">报关订单总金额（含税）：{{ orderDetailInfo.orderCustomsInfo.totalAmount }}</y-query-item>
          <y-query-item :class="css.query_item">报关总税金：{{ orderDetailInfo.orderCustomsInfo.totalTax }}</y-query-item>
          <y-query-item :class="css.query_item">报关总运费：{{ orderDetailInfo.orderCustomsInfo.shippingFee }}</y-query-item>
          <y-query-item :class="css.query_item">报关总优惠券金额：{{ orderDetailInfo.orderCustomsInfo.bonusMoney }}</y-query-item>
        </y-query>
      </y-form>
      <div class="spliter"></div>
      <y-form title="商品信息" id="goods" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <k-table :data="orderDetailInfo.orderGoodsList" :class="css.tableW" max-height="600px" :columns="initColumnGoods()"></k-table>
      </y-form>
      <div class="spliter"></div>
      <y-form title="物流信息" id="shipping" gutter="25px 30px" titleAlign="left" titleWidth="120px" contentWidth="500px">
        <k-table
          :data="orderDetailInfo.orderLogisticsList"
          :class="css.tableW"
          max-height="600px"
          :rightFixedNumber="1"
          :columns="initColumns()"
        ></k-table>
      </y-form>
      <div class="spliter"></div>
    </div>
    <y-anchor :anchor="anchorList"></y-anchor>
    <k-popup layout="header,body,close,mask" title="查看详情" :show.sync="isPopupShow">
      <y-popup-body size="small">
        <y-form titleAlign="left" titleWidth="70px" contentWidth="200px">
          <img :src="orderDetailInfo.orderAddress.buyerIdCardFront" alt="" v-if="this.showType == 1"/>
          <img :src="orderDetailInfo.orderAddress.buyerIdCardBack" alt="" v-if="this.showType == 2"/>
          <img :src="orderDetailInfo.payVoucher" alt="" v-if="this.showType == 3"/>
        </y-form>
      </y-popup-body>
    </k-popup>
  </y-view>
</template>

<script>
import { NESTLE_TRADE_BACK_SERVER_ORDERS_DETAIL } from '@/assets/modules/apiList';

export default {
  data() {
    return {
      isPopupShow: false,
      showType: 0, // 1 身份证人像面; 2 身份证国徽面; 3 支付凭证;
      orderDetailInfo: {
        orderAddress: {
          consignee: '',
          consigneeMobile: '',
          orderStatusName: '',
        },
        orderPayment: {
          payName: '',
          payAmount: '',
          payTime: '',
          transactionNo: ''
        },
        orderCustomsInfo: {
          no: '',
          customs: '',
          ebpName: '',
          ebpCode: '',
          totalAmount: '',
          totalTax: '',
          shippingFee: '',
          bonusMoney: ''
        }
      },
      anchorList: [
        {
          id: 'basic',
          text: '基本信息'
        },
        {
          id: 'recive',
          text: '收货信息'
        },
        {
          id: 'pay',
          text: '支付信息'
        },
        {
          id: 'customs',
          text: '报关信息'
        },
        {
          id: 'goods',
          text: '商品信息'
        },
        {
          id: 'shipping',
          text: '物流信息'
        }
      ]
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: '物料编码',
          field: 'goodsCode',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '商品数量',
          field: 'qty',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '物流公司名称',
          field: 'providerName',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '运单号',
          field: 'trackNo',
          style: {
            width: 180,
            textAlign: 'center'
          }
        }
      ];
    },
    initColumnGoods() {
      return [
        {
          name: '商品名称',
          field: 'goodsNameSale',
          style: {
            width: 250,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '货号',
          field: 'goodsCodeSale',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '物料编码',
          field: 'goodsCode',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '仓库',
          field: 'wearSeatName',
          style: {
            width: 180,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '批次号',
          field: 'saleBatchNo',
          style: {
            width: 180,
            textAlign: 'center',
            'white-space': 'normal',
            'line-height': '18px'
          }
        },
        {
          name: '规格',
          field: 'spec',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '件数',
          field: 'specQty',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '总数量',
          field: 'qty',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '销售单价',
          field: 'finalPrice',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '商品总额',
          field: 'goodsAmount',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '税金',
          field: 'totalTax',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '运费',
          field: 'shippingFee',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '活动优惠',
          field: 'activityDiscount',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '优惠券',
          field: 'bonusDiscount',
          style: {
            width: 180,
            textAlign: 'center'
          }
        },
        {
          name: '合计',
          field: 'payAmount',
          style: {
            width: 180,
            textAlign: 'center'
          }
        }
      ];
    },
    getorderInfo(orderSn) {
      this.isLoading = true;
      this.$fetch({
        api: NESTLE_TRADE_BACK_SERVER_ORDERS_DETAIL,
        para: { orderSn: orderSn }
      })
        .then(res => {
          this.orderDetailInfo = res || {};
          this.orderDetailInfo.orderPayment = res.orderPayment ? res.orderPayment : {};
          if (this.orderDetailInfo.orderGoodsList && this.orderDetailInfo.orderGoodsList.length > 0) {
            this.orderDetailInfo.orderGoodsList.push({
              goodsAmount: this.orderDetailInfo.goodsAmount,
              totalTax: this.orderDetailInfo.totalTax,
              shippingFee: this.orderDetailInfo.shippingFee,
              activityDiscount: this.orderDetailInfo.activityDiscount,
              bonusDiscount: this.orderDetailInfo.bonusDiscount,
              payAmount: this.orderDetailInfo.payAmount
            });
          }
          this.orderDetailInfo.orderCustomsInfo = this.orderDetailInfo.orderCustomsInfo ? this.orderDetailInfo.orderCustomsInfo : {};
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    previewImg(v) {
      this.showType = v;
      this.isPopupShow = true;
    }
  },
  created() {
    const { orderSn } = this.$route.query;
    if (orderSn) {
      this.getorderInfo(orderSn);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { orderSn } = to.query;
    if (orderSn) {
      this.getorderInfo(orderSn);
    }
    next();
  }
};
</script>

<style lang="postcss" module="css">
.query {
  display: flex;
  flex-direction: row;
  & > div {
    width: 100% !important;
  }
}
.query_item {
  width: 23% !important;
}
.tableW {
  width: 82%;
}
</style>
